import { c as _c } from "react/compiler-runtime";
import { useMembersMenuOptions } from "@pages/members/use-members-menu-options";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
import { useSetMemberTableType } from "@hooks/table/use-set-member-table-type";
/**
 * Mobile-specific view for members list.
 * Renders a virtualized list of members with selection, menu options, and bulk actions.
 */
export function MembersMobileView(t0) {
  const $ = _c(9);
  const {
    members,
    bulkActionButtons,
    isLoading,
    tableSubject,
    sortBy
  } = t0;
  useSetMemberTableType(tableSubject);
  let t1;
  if ($[0] !== tableSubject) {
    t1 = {
      subjectType: tableSubject
    };
    $[0] = tableSubject;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const menuItems = useMembersMenuOptions(t1);
  let t2;
  if ($[2] !== bulkActionButtons || $[3] !== isLoading || $[4] !== members || $[5] !== menuItems || $[6] !== sortBy || $[7] !== tableSubject) {
    t2 = <MemberMobileList members={members} isLoading={isLoading} bulkActionButtons={bulkActionButtons} tableSubject={tableSubject} menuItems={menuItems} sortBy={sortBy} />;
    $[2] = bulkActionButtons;
    $[3] = isLoading;
    $[4] = members;
    $[5] = menuItems;
    $[6] = sortBy;
    $[7] = tableSubject;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}